// Copyright (c) 2019 Deere & Company

import '../../../styles/table.scss';
import { AgGridReact } from 'ag-grid-react';
import { BaseCodeColumnDefinitions } from '../ag-grid-definations/basecodeSearch';
import PropTypes from 'prop-types';
import React from 'react';

const rowSelection = 'single';

function onGridReady ( params ) {

    this.gridApi = params.api;

}


function handleBaseCodeSelect ( obj, params ) {

    const selectedRows = params.api.getSelectedRows();
    let selectedRowsString = '';
    selectedRows.forEach( ( selectedRow, index ) => {

        if ( index !== 0 ) {

            selectedRowsString += ', ';

        }
        selectedRowsString = selectedRow;

    } );
    obj.handleBaseCodeSelect( selectedRowsString );

}

const BasecodeSearchPanel = props => (
    <section>
        <div>
            <div>
                {( props.mode === 'SEARCH' ) && props.productList.length > 0 && (
                    <div
                        className="ag-theme-balham ag-theme-popupbg"
                    >
                        <AgGridReact
                            columnDefs={BaseCodeColumnDefinitions}
                            rowData={props.productList}
                            onGridReady={onGridReady}
                            rowSelection={rowSelection}
                            onSelectionChanged={handleBaseCodeSelect.bind( this, props )}
                            popupParent={document.body}
                        />
                    </div>
                )}
                {( props.mode === 'SEARCH' ) && props.productList.length === 0 && <div className="no-search-result">No Matching Results Found</div>}

            </div>
        </div>
    </section>
);

BasecodeSearchPanel.displayName = 'BasecodeSearchPanel';
BasecodeSearchPanel.propTypes = {
    productList: PropTypes.array.isRequired,
    mode: PropTypes.string.isRequired,
    getHighlightedText: PropTypes.func,
};

export default BasecodeSearchPanel;
